import { FuelTransaction } from '@/src/types/FuelTransaction';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useState } from 'react';
import { useFuelTransaction } from '../hooks/useFuelTransaction';
import { Dialog } from '../../ui/Dialog';
import { getFormattedDate } from '../../../lib/dateUtils';
import { toast } from 'react-toastify';
import { Role } from '../../../types/Role';
import { UserContext } from '../../../context/UserProvider';
import { Button } from '../../ui/Button';

export const MarkFuelTransactionAsSubtituteCarUsage = ({ fuelTransaction }: { fuelTransaction: FuelTransaction }) => {
    const { userRole } = useContext(UserContext);
    const [isOpen, setIsOpen] = useState(false);
    const markAsSubstituteCarUsage = useFuelTransaction().markAsSubstituteCarUsage();

    const handleMarkAsSubsituteCarUsage = (fuelTransaction: FuelTransaction) => {
        markAsSubstituteCarUsage.mutate(fuelTransaction.id, {
            onSuccess: (result: any) => {
                setIsOpen(false);
                toast('Tankbeurt succesvol als vervangend vervoer gemarkeerd.');
            },
            onError: () => {
                toast.error('Tankbeurt kon niet als vervangend vervoer gemarkeerd worden. Probeer het later nog eens.');
            }
        });
    };

    return (
        <>
            <Button.Icon onClick={() => setIsOpen(true)} aria-label="set as substitute car usage" title="Markeer als vervangend vervoer">
                <FontAwesomeIcon icon={faTag} className="text-lg" />
            </Button.Icon>

            <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
                <>
                    <Dialog.Title>Markeren als vervangend vervoer</Dialog.Title>
                    <div className="my-4">
                        Weet je zeker dat je de tankbeurt op <b>{`${getFormattedDate(fuelTransaction.transactionDate)}`}</b> wilt markeren als vervangend vervoer?
                    </div>
                    <div className="flex justify-end">
                        <Button onClick={() => handleMarkAsSubsituteCarUsage(fuelTransaction)} loading={markAsSubstituteCarUsage.isPending}>
                            Markeren
                        </Button>
                    </div>
                </>
            </Dialog>
        </>
    );
};
